export enum MubiInstallmentsLenderEnum {
  HiPro = 'hipro',
}

const mubiInstallmentsLenderKeys: readonly string[] = Object.values(
  MubiInstallmentsLenderEnum
);

export const isMubiInstallmentsLenderKey = (value: unknown): boolean =>
  value != null && mubiInstallmentsLenderKeys.includes(String(value));
